const continents = {
  Africa: {
    ZW: 'Zimbabwe',
    ZM: 'Zambia',
    UG: 'Uganda',
    TN: 'Tunisia',
    TG: 'Togo',
    TZ: 'Tanzania',
    SZ: 'Swaziland',
    SD: 'Sudan',
    ZA: 'South Africa',
    SO: 'Somalia',
    SL: 'Sierra Leone',
    SC: 'Seychelles',
    SN: 'Senegal',
    RW: 'Rwanda',
    NG: 'Nigeria',
    NE: 'Niger',
    NA: 'Namibia',
    MZ: 'Mozambique',
    MA: 'Morocco',
    MR: 'Mauritania',
    ML: 'Mali',
    MW: 'Malawi',
    MG: 'Madagascar',
    LY: 'Libya',
    LR: 'Liberia',
    LS: 'Lesotho',
    KE: 'Kenya',
    GW: 'Guinea Bissau',
    GN: 'Guinea',
    GH: 'Ghana',
    GM: 'Gambia',
    GA: 'Gabon',
    ET: 'Ethiopia',
    ER: 'Eritrea',
    GQ: 'Equatorial Guinea',
    CF: 'Central African Republic',
    EG: 'Egypt',
    DJ: 'Djibouti',
    CI: 'Ivory Coast',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Democratic Republic Congo',
    TD: 'Chad',
    CV: 'Cape Verde',
    CM: 'Cameroon',
    BI: 'Burundi',
    BF: 'Burkina Faso',
    BW: 'Botswana',
    DZ: 'Algeria',
    AO: 'Angola',
    BJ: 'Benin',
  },
  South_America: {
    VE: 'Venezuela',
    UY: 'Uruguay',
    PE: 'Peru',
    PY: 'Paraguay',
    EC: 'Ecuador',
    CO: 'Colombia',
    CL: 'Chile',
    BR: 'Brazil',
    BO: 'Bolivia',
    AR: 'Argentina',
  },
  North_America: {
    US: 'United States',
    PA: 'Panama',
    MX: 'Mexico',
    JM: 'Jamaica',
    HN: 'Honduras',
    HT: 'Haiti',
    GT: 'Guatemala',
    GP: 'Guadeloupe',
    GD: 'Grenada',
    DO: 'Dominican Republic',
    CU: 'Cuba',
    CA: 'Canada',
    BM: 'Bermuda',
    BZ: 'Belize',
    BB: 'Barbados',
    AI: 'Anguilla',
    AG: 'Antigua And Barbuda',
    BS: 'Bahamas',
  },
  Europe: {
    GB: 'United Kingdom',
    UA: 'Ukraine',
    CH: 'Switzerland',
    SE: 'Sweden',
    ES: 'Spain',
    SI: 'Slovenia',
    SK: 'Slovakia',
    RS: 'Serbia',
    SM: 'San Marino',
    RO: 'Romania',
    PT: 'Portugal',
    TR: 'Turkey',
    RU: 'Russian Federation',
    PL: 'Poland',
    NO: 'Norway',
    NL: 'Netherlands',
    ME: 'Montenegro',
    MC: 'Monaco',
    MD: 'Moldova',
    MT: 'Malta',
    MK: 'Macedonia',
    LU: 'Luxembourg',
    LT: 'Lithuania',
    LI: 'Liechtenstein',
    LV: 'Latvia',
    IT: 'Italy',
    IE: 'Ireland',
    IS: 'Iceland',
    HU: 'Hungary',
    GR: 'Greece',
    GI: 'Gibraltar',
    DE: 'Germany',
    FR: 'France',
    FI: 'Finland',
    EE: 'Estonia',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    HR: 'Croatia',
    BG: 'Bulgaria',
    BA: 'Bosnia And Herzegovina',
    BE: 'Belgium',
    BY: 'Belarus',
    AL: 'Albania',
    AD: 'Andorra',
    AT: 'Austria',
  },
  Asia: {
    YE: 'Yemen',
    VN: 'Vietnam',
    UZ: 'Uzbekistan',
    TM: 'Turkmenistan',
    TH: 'Thailand',
    TJ: 'Tajikistan',
    TW: 'Taiwan',
    SY: 'Syria',
    LK: 'Sri Lanka',
    SG: 'Singapore',
    SA: 'Saudi Arabia',
    QA: 'Qatar',
    PH: 'Philippines',
    IL: 'Palestina',
    PK: 'Pakistan',
    OM: 'Oman',
    NP: 'Nepal',
    MM: 'Myanmar',
    MN: 'Mongolia',
    MV: 'Maldives',
    MY: 'Malaysia',
    LB: 'Lebanon',
    KG: 'Kyrgyzstan',
    KW: 'Kuwait',
    KR: 'Korea',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    JP: 'Japan',
    IQ: 'Iraq',
    IR: 'Iran',
    ID: 'Indonesia',
    IN: 'India',
    HK: 'Hong_Kong',
    KH: 'Cambodia',
    CN: 'China',
    BN: 'Brunei Darussalam',
    BT: 'Bhutan',
    AF: 'Afghanistan',
    BH: 'Bahrain',
    BD: 'Bangladesh',
  },
  Oceania: {
    WS: 'Samoa',
    PG: 'Papua New Guinea',
    NZ: 'New Zealand',
    AU: 'Australia',
    FJ: 'Fiji',
  },
};

const getContinent = (inputCountry) => {
  let countryContinent = '';
  Object.keys(continents).forEach((continent) => {
    Object.values(continents[continent]).forEach((country) => {
      if (inputCountry === country) {
        countryContinent = continent;
      }
    });
  });
  return countryContinent;
};

const loadDataByContinent = (countriesData) => {
  const continentsData = {
    Africa: { name: 'Africa', countries: [] },
    Europe: { name: 'Europe', countries: [] },
    North_America: { name: 'North_America', countries: [] },
    Oceania: { name: 'Oceania', countries: [] },
    Asia: { name: 'Asia', countries: [] },
    South_America: { name: 'South_America', countries: [] },
  };

  countriesData.forEach((c) => {
    // const countryCode = c.CountryCode;
    const continent = getContinent(c.Country);
    if (continent) {
      continentsData[continent].countries.push({
        id: c.ID,
        name: c.Country,
        slug: c.Slug,
        totalConfirmed: c.TotalConfirmed,
        totalDeaths: c.TotalDeaths,
        totalRecovered: c.TotalRecovered,
        newConfirmed: c.NewConfirmed,
        newDeaths: c.NewDeaths,
        newRecovered: c.NewRecovered,
      });
    }
  });
  return continentsData;
};

export default loadDataByContinent;
